import React from "react";
import { Card } from "react-bootstrap";
import PageLoader from "../components/PageLoader";

const LoggedInLayout = ({ children, title, isLoading }) => {
  return (
    <PageLoader isActive={isLoading}>
      <div>
        <Card>
          <Card.Body>
            <Card.Title as="h2" className="mb10">
              {title}
            </Card.Title>
            {children}
          </Card.Body>
        </Card>
      </div>
    </PageLoader>
  );
};

export default LoggedInLayout;
